import { useEffect, useState } from 'react';

/**
 * Where the desktop layout begins. The same width as the `@media` block in
 * theme.css that lays it out, so the screen the markup builds and the shape
 * the stylesheet gives it change over together.
 */
export const WIDE_QUERY = '(min-width: 900px)';

function matches(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(WIDE_QUERY).matches
    : false;
}

/** Whether the window is wide enough for the desktop layout, kept up as it is resized. */
export function useWide(): boolean {
  const [wide, setWide] = useState(matches);
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(WIDE_QUERY);
    const changed = () => setWide(query.matches);
    changed();
    query.addEventListener('change', changed);
    return () => query.removeEventListener('change', changed);
  }, []);
  return wide;
}
